import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isTemplateMode: false,
  currentTemplateName: '',
  currentProduct: null,
  variableElements: {}, // { elementId: { variableName, type, imageIndex? } }
  selectedTemplateId: null,
  showTemplateModal: false,
};

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setTemplateMode: (state, action) => {
      state.isTemplateMode = action.payload;
    },
    setCurrentTemplateName: (state, action) => {
      state.currentTemplateName = action.payload;
    },
    setCurrentProduct: (state, action) => {
      state.currentProduct = action.payload;
    },
    addVariableElement: (state, action) => {
      const { elementId, variableName, type, imageIndex } = action.payload;
      state.variableElements[elementId] = { variableName, type, imageIndex };
    },
    removeVariableElement: (state, action) => {
      delete state.variableElements[action.payload];
    },
    clearVariableElements: (state) => {
      state.variableElements = {};
    },
    setSelectedTemplateId: (state, action) => {
      state.selectedTemplateId = action.payload;
    },
    setShowTemplateModal: (state, action) => {
      state.showTemplateModal = action.payload;
    },
    resetTemplateState: (state) => {
      return initialState;
    },
  },
});

export const {
  setTemplateMode,
  setCurrentTemplateName,
  setCurrentProduct,
  addVariableElement,
  removeVariableElement,
  clearVariableElements,
  setSelectedTemplateId,
  setShowTemplateModal,
  resetTemplateState,
} = templateSlice.actions;

export default templateSlice.reducer;
